import { DeviceTaskExecutionResult } from './TaskExecutionResult';
export class DeviceTaskPairExecutionResult {
    constructor() {
        this.Device = null;
        this.Channel = 0;
        this.Task = null;
        this.Result = DeviceTaskExecutionResult.Unknown;
    }
}
//# sourceMappingURL=IDevicesService.js.map